import { convertToNumber } from 'utils/converters';

import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';

import useGetRowData from '../hooks/useGetRowData';
import CreateEditDistancesForm from './CreateEditDistancesForm';
import { EditDistancesSkeleton } from './EditDistancesSkeleton';

export default function CreateEditDistances({
  handleClose,
  rowId
}: FormComponentProps) {
  const { isFetching, data } = useGetRowData(convertToNumber(rowId));

  return isFetching ? (
    <EditDistancesSkeleton />
  ) : (
    <CreateEditDistancesForm handleClose={handleClose} rowData={data} />
  );
}
